import { DEFAULT_FOLDER_ID, virtualFolderNames } from "../constants";

const isPersonalFolder = (folderId: string | undefined) => {
  if (folderId === undefined) {
    return true;
  }
  return (
    folderId === DEFAULT_FOLDER_ID ||
    virtualFolderNames[folderId] === DEFAULT_FOLDER_ID
  );
};

export default isPersonalFolder;
